
import { useIntl } from "react-intl";

import { Grid } from "@mui/material";

import DynamicArticles from "../dynamic-articles-external";

export default function CommonExternalDynamicArticles({ clientportal, hirerid, setNotification }) {
  const intl = useIntl();

  return (
    <Grid item container direction="row" spacing={2} justifyContent="space-around">
      {
        clientportal?.showpromotedarticles &&
        <DynamicArticles
          intl={intl}
          title={intl.formatMessage({ id: "promoted.articles" })}
          hirerid={hirerid}
          type="promoted"
          count={clientportal?.promotedarticlesamount}
          setNotification={setNotification}
          defaulttextcolor={clientportal?.defaulttextcolor}
        />
      }
      {
        clientportal?.showbestratedarticles &&
        <DynamicArticles
          intl={intl}
          title={intl.formatMessage({ id: "best.rated.articles" })}
          hirerid={hirerid}
          type="bestrated"
          count={clientportal?.bestratedarticlesamount}
          setNotification={setNotification}
          defaulttextcolor={clientportal?.defaulttextcolor}
        />
      }
      {
        clientportal?.showmostviewedarticles &&
        <DynamicArticles
          intl={intl}
          title={intl.formatMessage({ id: "most.viewed.articles" })}
          hirerid={hirerid}
          type="mostviewed"
          count={clientportal?.mostviewedarticlesamount}
          setNotification={setNotification}
          defaulttextcolor={clientportal?.defaulttextcolor}
        />
      }
      {
        clientportal?.showrecentarticles &&
        <DynamicArticles
          intl={intl}
          title={intl.formatMessage({ id: "recent.articles" })}
          hirerid={hirerid}
          type="recent"
          count={clientportal?.recentarticlesamount}
          setNotification={setNotification}
          defaulttextcolor={clientportal?.defaulttextcolor}
        />
      }
    </Grid>
  )
}